import { useEffect } from 'react';
import { Trans } from '@lingui/react/macro';
import { Button } from '@pocketlaw/tetris';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { AccessTokenExpiredDialog } from 'app/domains/auth/components/AccessTokenExpiredDialog';
import useAuthRedirect from 'app/domains/auth/components/useAuthRedirect';
import { useAuth } from 'app/domains/auth/hooks/useAuth';
import { GlobalProviders } from 'app/domains/init';
import useSendGtmData from 'app/domains/tracking/hooks/useSendGtmData';
import { PageLoader } from 'shared/domains/common-ui';
import { AppError } from 'shared/domains/errors';
import * as Sentry from 'shared/domains/sentry'; // TODO: better import path or location
import { useGetLinks } from 'shared/domains/urls';
import useInit from './useInit';
/**
 * Routes that require auth to access
 */
export function AuthRoutes(props) {
    var _a, _b, _c;
    const { children } = props;
    const location = useLocation();
    const auth = useAuth();
    const initQuery = useInit({ skip: !((_b = (_a = auth.data) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.userId) });
    const links = useGetLinks();
    const { account, profile } = (_c = initQuery.data) !== null && _c !== void 0 ? _c : {};
    const { userId, verified } = profile !== null && profile !== void 0 ? profile : {};
    const { companyId } = account || {};
    const redirectingToLogin = useAuthRedirect();
    const loading = auth.loading || redirectingToLogin || initQuery.loading;
    const error = !userId || auth.error || initQuery.error;
    useSendGtmData({ skip: Boolean(loading || error) });
    useEffect(() => {
        Sentry.getCurrentScope()
            .setUser({
            id: userId,
        })
            .setTag('companyId', companyId);
    }, [userId, companyId]);
    if (loading) {
        return <PageLoader />;
    }
    if (!companyId) {
        return (<AppError code={400} title={<Trans comment="Authentication: No company attached to the user">No company</Trans>} message={<Trans comment="Authentication: No company attached to the user">
            You do not have any company associated with your user. Please contact support.
          </Trans>} action={<Button as="a" href={links.contact} rel="noopener noreferrer" size="small">
            <Trans comment="Authentication: No company attached to the user">Contact support</Trans>
          </Button>}/>);
    }
    if (error) {
        return (<AppError code={400} message={<Trans>
            There was an error when we tried to authenticate you. Please try to reload the page. Please contact us if
            this message persists.
          </Trans>}/>);
    }
    if (!verified && location.pathname !== '/verify') {
        return <Redirect to="/verify"/>;
    }
    return (<Route>
      <GlobalProviders>
        <Switch>{children}</Switch>
        <AccessTokenExpiredDialog />
      </GlobalProviders>
    </Route>);
}
